const routes = [
	{
		index: true,
		label: 'Vadim Isakov',
		path: '/',
	},
	{
		label: 'About',
		path: '/about',
	},
	{
		label: 'Resume',
		path: '/resume',
	},
	{
		label: 'Projects',
		path: '/projects',
	},
	{
		label: 'Stats',
		path: '/stats',
	},
	{
		label: 'Contact',
		path: '/contact',
	},
	// {
	// 	label: 'Blog',
	// 	path: '/blog',
	// },
];

export default routes;
